export const queryKeys = {
  auth: {
    all: ['auth'] as const,
    role: ['auth', 'role'] as const,
    sessions: ['auth', 'sessions'] as const,
  },

  loads: {
    all: ['loads'] as const,
    list: (filters: Record<string, unknown>) => ['loads', filters] as const,
    detail: (id: string | number) => ['loads', id] as const,
    bids: (id: string | number) => ['loads', id, 'bids'] as const,
    documents: (id: string | number) => ['loads', id, 'documents'] as const,
    stats: ['loads', 'stats'] as const,
  },

  vehicles: {
    all: ['vehicles'] as const,
    list: (filters: Record<string, unknown>) => ['vehicles', filters] as const,
    detail: (id: string | number) => ['vehicles', id] as const,
  },

  routes: {
    all: ['routes'] as const,
    list: (filters: Record<string, unknown>) => ['routes', filters] as const,
    detail: (id: string | number) => ['routes', id] as const,
  },

  locations: {
    all: ['locations'] as const,
    search: (query: string) => ['locations', 'search', query] as const,
  },

  matching: {
    all: ['matching'] as const,
    list: (filters: Record<string, unknown>) => ['matching', filters] as const,
    detail: (loadId: string | number, routeId: string | number) =>
      ['matching', loadId, routeId] as const,
  },

  pipeline: {
    all: ['pipeline'] as const,
    filtered: (
      search: string,
      countries: string | undefined,
      loadTypes: string | undefined,
      sortOrder: string,
      showAllCompleted: boolean,
    ) => ['pipeline', { search, countries, loadTypes, sortOrder, showAllCompleted }] as const,
  },

  bids: {
    forLoad: (loadId: string | number) => ['bids', 'load', loadId] as const,
  },

  company: {
    me: ['company', 'me'] as const,
    documents: ['company', 'documents'] as const,
    verification: ['company', 'verification'] as const,
  },

  insights: {
    all: ['insights'] as const,
    analytics: ['insights', 'analytics'] as const,
  },

  notifications: {
    all: ['notifications'] as const,
    list: (page: number) => ['notifications', 'list', page] as const,
    unreadCount: ['notifications', 'unread-count'] as const,
  },
}
